/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Spreadsheet_RequiredInputs */

const fr_api_drive_spreadsheet_required = /** @type {(inputs: Api_Drive_Spreadsheet_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un fichier Google Sheets.`)
};

const en_api_drive_spreadsheet_required = /** @type {(inputs: Api_Drive_Spreadsheet_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a Google Sheets file.`)
};

/**
* | output |
* | --- |
* | "Select a Google Sheets file." |
*
* @param {Api_Drive_Spreadsheet_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_spreadsheet_required = /** @type {((inputs?: Api_Drive_Spreadsheet_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Spreadsheet_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_spreadsheet_required(inputs)
	return fr_api_drive_spreadsheet_required(inputs)
});